/* eslint-disable import/no-unresolved */
import { formatDate } from '@angular/common';

export function dateFormat(date: Date | string) :string|undefined {
  if (!date) {
    return undefined;
  }
   return formatDate(date, "yyyy-MM-dd", "hu-HU");
}
